export default "__VITE_ASSET__C_Fuf1IF__"